// ─── Shared: resolve sendTo URL ───────────────────────────────────────────────
export const resolveSendToUrl = (el, sendTo) => {
  if (el.Requester === "" || el.Requester === "Sales")
    return `${sendTo.url}/api/itemissuer/receiver`;
  if (el.type === "Plant") return `${sendTo.url}/api/production/issue-items`;
  return `${sendTo.url}/api/warehouse/receiver`;
};

export function calculateDate(periodTime, period, from = new Date()) {
  const date = new Date(from);

  const handlers = {
    day: () => date.setDate(date.getDate() - periodTime),
    days: () => date.setDate(date.getDate() - periodTime),

    month: () => date.setMonth(date.getMonth() - periodTime),
    months: () => date.setMonth(date.getMonth() - periodTime),

    year: () => date.setFullYear(date.getFullYear() - periodTime),
    years: () => date.setFullYear(date.getFullYear() - periodTime),
  };

  const handler = handlers[period.toLowerCase()];

  if (!handler) {
    throw new Error(`Unsupported unit: ${period}`);
  }

  handler();
  return date;
}
